import React from 'react'

const KellerkindLogo = props => {
  return (
    <path
      d="m86.7142857 48.2947504v-15.0090361h-53.4285714v53.4285714h15.0090361v-12.8894686h12.7650334v-12.7650333h12.7650333v-12.7650334zm-60.7142857-22.2947504h68v68h-68z"
      fillRule="evenodd"
    />
  )
}

export default KellerkindLogo
